import { Activity } from "lucide-react";

export function StatMini({ label, value, accent, testid }) {
  return (
    <div data-testid={testid} className={`card-flat p-4 ${accent === "brand" ? "border-l-4 border-l-[#2F4F4F]" : ""}`}>
      <div className="text-[10px] tracking-[0.2em] uppercase text-[var(--muted-text)]">{label}</div>
      <div className="font-mono-data text-lg font-semibold mt-1 truncate">{value}</div>
    </div>
  );
}


// =============================================================
// Activity panel — dividend / interest / buy / sell / fee
// Each activity is mirrored to /transactions so it flows into the
// entity's P&L and cash-flow. Buy/Sell also mutate the position's
// quantity + cost_basis; the backend returns realized_gain on sells.
// =============================================================
